import React, { Ref, HTMLAttributes, forwardRef } from "react";

import classnames from "classnames";

import { StyledCard } from "./Styles";

export interface ICardProps {
  /** Choose if card should be hoverable or not */
  hoverable?: boolean;
  /** Set the type of the Paper */
  variant?: "paper-1" | "paper-2" | "tile-1" | "tile-2";
  /** Ref element */
  ref?: Ref<HTMLDivElement>;
}

export const Card = forwardRef(
  (
    {
      children,
      className,
      hoverable = false,
      variant = "paper-2",
      onClick,
      ...rest
    }: HTMLAttributes<HTMLDivElement> & ICardProps,
    ref: Ref<HTMLDivElement> | null | undefined
  ) => {
    return (
      <StyledCard
        {...rest}
        type={variant}
        className={classnames("c-card", className)}
        hover={hoverable}
        $pointer={typeof onClick === "function"}
        onClick={onClick}
        useOptimizedShadow
        ref={ref}
      >
        {children}
      </StyledCard>
    );
  }
);

Card.displayName = "Card";
